import { render, staticRenderFns } from "./ChooseCustomer.view.vue?vue&type=template&id=16b1dc1c&scoped=true&"
import script from "./ChooseCustomer.view.vue?vue&type=script&lang=ts&"
export * from "./ChooseCustomer.view.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseCustomer.view.vue?vue&type=style&index=0&id=16b1dc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1dc1c",
  null
  
)

export default component.exports